const { Report_blockchain_service } = require('../services/Report_blockchain.service')
import { Loading } from "element-ui"

const state = {
    transaction: [],
    total: null,
    data_detail: null,
    service_type: ''
}

const actions = {
    async getBlockchainTransaction({commit}, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        commit('SET_SERVICE_TYPE', data.form.service_type)
        let result = await Report_blockchain_service.getBlockchainTransaction(data);
        if(result.status == 200) {
            commit('SET_TRANSACTION', result.data)
            let total = result.data[0] ? result.data[0].total : 0
            commit('COUNTING',total)
            setTimeout(function(){ loadingInstance.close() }, 250);
        }
    },
    async checkTransection({commit}, txn) {
        let blockchain_detail = await Report_blockchain_service.checkTransection({transection: txn});
        if (blockchain_detail.status == 200) {
            let data = await Report_blockchain_service.checkData({data: blockchain_detail.result.input});
            if (data.status == 200) {
                commit('SET_DETAIL', data.result)
            } else {
                MessageBox.confirm(data.message, 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                })
            }
        } else {
            MessageBox.confirm(blockchain_detail.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
        
    }
}

const mutations = {
    SET_SERVICE_TYPE(state, type){
        state.service_type = type
    },
    SET_TRANSACTION(state, obj){
        state.transaction = []
        for (let i = 0; i < obj.length; i++) {
            state.transaction.push(obj[i])
        }
    },
    COUNTING(state, obj){
        state.total = obj
    },
    SET_DETAIL(state, data){
        state.data_detail = data
    }
}

export const Report_blockchain = {
    namespaced: true,
    state,
    actions,
    mutations
}